export const FrenchLabel = {
    Enter_the_following_information_to_enter: 'Saisir les informations suivantes pour entrer',
    login: 'Identifiants',
    Username: "Nom d'utilisateur",
    password: 'Mot de passe',
    Orders: 'Commandes',
    Online: 'En ligne',
    Offline: 'Hors ligne',
    Info: 'Info',
    email: 'Adresse mail',
    vehicletypes: 'Types de services',
    loginstatus: 'Statut de connexion',
    lastonlinetime: 'Dernière heure de connexion',
    fetchingdata: "Recpetion de l'information...",
    poperLoading: 'Patientez svp',
    Noinformationfound: 'Aucune information trouvée',
    Drivers: 'Chauffeurs/Livreurs',
    otherdropoffs: 'autres dépôts',
    paymentmethod: 'Méthode de paiement',
    Receiver: 'Par le destinataire',
    Sender: "Par l'expéditeur",
    Balance: 'Crédit',
    Cash: 'Espèces',
    Wallet: 'Crédit',
    Close: 'Fermer',
    noVehicleType: "Il n'y a pas de type de service à afficher",
    Fname: 'Vore prénom',
    Lname: 'Votre nom',
    Pnumber: 'Numéro de téléphone',
    driver: 'Chauffeur/Livreur',
    DropOff: 'Dépôt',
    Noaddressavailable: 'Aucune adresse disponible',
    Managefavoriteaddresses: 'Gestion des adresses',
    address: 'Adresse',
    Saved: 'Enregistré',
    block: 'Bâtiment ',
    Floor: 'Etage',
    Unit: 'Unité',
    Recieverfullname: 'Nom de destinataire',
    Recieverphonenumber: 'Numéro du destinataire',
    notesfordriver: 'Notes pour le Chauffeur/Livreur',
    Price: 'Prix',
    EditOrder: 'Modifier',
    Firstname: 'Prénom',
    Lastname: 'Nom de famille',
    Phonenumber: 'Téléphone',
    senderfullname: "Nom de l'expéditeur",
    senderphonenumber: "Numéro de l'expéditeur",
    Search: 'Rechercher',
    Service: 'service',
    Passenger: 'Customer',
    Pickup: 'Ramassage',
    Pricedetails: 'Détails du prix',
    Fee: 'Frais',
    Fornow: 'Immédiat',
    Scheduled: 'Programmé',
    before: 'avant :',
    Settime: "Définir l'heure",
    after: 'après :',
    confirm: 'Confirmer',
    Cancel: 'Annuler',
    Addresses: 'Adresses',
    Savedaddresses: 'Adresses enregistrées',
    new: 'Nouvelle',
    Editaddress: "Modifier l'adresse",
    Saveaddress: "Enregistrer l'adresse",
    Language: 'Langue',
    en: 'Anglais',
    fa: 'Persian',
    English: 'Anglais',
    Persian: 'Persian',
    Logout: 'Déconnecter',
    logotTitle: 'Se déconnecter du compte ?',
    logoutDescription: 'Vous serez déconnecté de votre compte et vous devrez vous reconnecter ultérieurement.',
    confirmLogout: 'Oui, déconnecter',
    skipLogout: 'Annuler',
    Ascending: 'Ascendant',
    Descending: 'Descendant',
    'sort[createdAt]': 'Date',
    'sort[pickupScheduleDate]': 'Horaire de ramassage',
    'sort[statusUpdatedAt]': 'Trier par mise à jour à',
    SelectDateRange: 'Plage de dates',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    Today: "Aujourd'hui",
    Yesterday: 'Hier',
    ThisWeek: 'Cette semaine',
    LastWeek: 'Semaine dernière',
    Last7Days: '7 derniers jours',
    ThisMonth: 'Ce mois',
    LastMonth: 'Le mois dernier',
    monitoring: 'Suivi',
    Haveorder: 'Faire une demande',
    Estimated: 'Estimé',
    ReceiverCash: 'Espèces (par le Destinataire)',
    SenderCash: "Espèces (par l'expéditeur)",
    SenderWallet: 'Porte-monnaie',
    Auto: 'Automatique',
    Manual: 'Manuel',
    SendOrderr: 'Envoyer ',
    Neworder: 'Nouvelle commande',
    Person: 'Particulier',
    Business: 'Professionnel',
    Businessname: "Nom de l'entreprise",
    phonenumber: 'Téléphone',
    Adddropoff: 'Ajouter',
    Searchbynameorphonenumber: 'Recherche par nom ou numéro de téléphone',
    Fullname: 'Nom complet',
    type: 'Type',
    only: 'xxx seulement',
    ChooseDriver: 'Choisir le chauffeur/livreur',
    AllKey: 'Tout',
    MeKey: 'Moi',
    Vehicletype: 'Type de véhicule',
    status: 'État',
    statusInProgress: 'En cours',
    statusCanceled: 'Annulé',
    statusPending: 'En attente',
    statusUnassigned: 'Non Assigné',
    statusDone: 'Finalisé',
    dispatcher: 'Opérateur',
    customer: 'Mobile',
    regexcode: 'Code',
    regexcustomerPhone: 'Annulé par le client',
    regexcustomerName: 'Nom du client',
    regexdriverPhone: 'Téléphone du Chauffeur/Livreur',
    regexdriverName: 'Nom du Chauffeur/Livreur',
    regexdriverUsername: "Nom d'utilisateur du Chauffeur/Livreur",
    pickupDescription: 'Description du ramassage',
    filter: 'Filtrer',
    clear: 'Effacer',
    orderInfoError: 'Erreur de réception des informations',
    Details: 'Détails',
    History: 'Historique',
    Phone: 'Téléphone',
    km: 'km',
    Espath: 'Es. path',
    Receipt: 'Reçu',
    Copylink: 'Copier le lien',
    repeatOrder: 'Répéter la demande',
    Edit: 'Modifier',
    EditPrice: 'Modifier le prix',
    Endtrip: 'Fin de la demande',
    Canceltravel: 'Annuler la demande',
    CancellText: "Après l'annulation, la commande est annulée pour le Chauffeur/Livreur.",
    confirmCancel: 'Ok',
    Endtravel: 'Terminé',
    EndlText: 'La commande du client et du chauffeur/livreur est alors traitée avec succès et le montant est déduit du compte du client.',
    confirmEnd: 'Oui',
    End: 'Annuler la commande',
    Deliveredat: 'Livré à',
    pod: 'Preuve de dépose',
    Notes: 'Notes',
    Nonotes: 'Aucune notes',
    Photo: 'Photo',
    Signature: 'Signature',
    Nosignature: 'Aucune signature',
    Nophoto: 'Aucune Photo',
    ServiceOptions: 'Options du service',
    Events: 'Evénements',
    status2: 'Status',
    Creator: 'Créateur',
    Creationdate: 'Date de création',
    Orderid: 'ID de commande',
    Pickup2: 'Ramassage',
    Dropoff2: 'Dépose',
    PleaseSelect: 'Veuillez sélectionner',
    CreateEvent: 'Créer un événement',
    Description: 'Description',
    detailsAboutEvent: 'Détails sur l’événement',
    CustomerVisibility: 'Visibilité client',
    LocationOnMap: 'Localisation sur la carte',
    Pending: 'En attente',
    Unassigned: 'Non assigné',
    Assigned: 'En cours',
    PickedUp: 'En cours',
    Started: 'En cours',
    Done: 'Finalisé',
    CustomerCanceled: 'Annulé',
    DriverCanceled: 'Annulé',
    SupportCanceled: 'Annulé',
    Arrived: 'En cours',
    Createdsuccessfully: 'Créé avec succès',
    Estime: 'Estimation de temps',
    Promocode: 'Code promo',
    Updatedsuccessfully: 'Mis à jour avec succès',
    statusAssigned: 'Assigné',
    statusStarted: 'Démarré',
    statusPickedUp: 'Démarré',
    statusDriverCanceled: 'Annulé par le Chauffeur/Livreur',
    statusArrived: 'Arrivé',
    statusSupportCanceled: 'Annulé par le service technique',
    Title: 'Titre',
    ContactFullname: 'Nom complet du contact',
    Contactphonenumber: 'Téléphone du contact',
    Commission: 'Commission',
    surcharge: 'Surtaxe',
    haslogined: "s'est connecté",
    Notloggedin: "ne s'est pas connecté",
    Schedule: 'Programmé',
    Date: 'Date',
    Time: 'Temps',
    noDateToShow: "Il n'y a pas de date à afficher",
    noTimeToShow: "Il n'y a pas d'heure à afficher",
    Apply: 'Appliquer',
    lowBalance: 'Solde Faible',
    balanceError: 'Votre solde doit être au moins égal au prix de la commande.',
    Methods: 'Méthodes',
    Addressbook: "Carnet d'adresses",
    AddressbookSearchbar: 'Recherche par adresse, titre et identifiant',
    AddressbookDropOf: "Carnet d'adresses (déposer)",
    AddressbookPickup: "Carnet d'adresses (ramassage)",
    hide: 'Cacher',
    Nosavedaddress: 'Aucune adresse enregistrée',
    Romanian: 'Individuel',
    business: 'Professionnel',
    username: "Nom d'utilisateur",
    rememberme: 'Se souvenir de moi',
    SendOrder: 'Envoyer',
    code: 'code',
    noorder: 'pas de requête',
    pleaseSellectParsel: 'Veuillez sélectionner le type de service',
    Order: 'Demander',
    Code: 'code',
    Editorder: 'Modifier',
    all: 'All',
    Address: 'Adresse',
    'Block/Building': 'Bloc / bâtiment',
    Pickedupat: 'Ramassé à ',
    for: 'Pour',
    fr: 'français',
    AllVehicletypes: 'Tous les types de services',
    AllServices: 'Tous les services',
    French: 'French',
    enterDataCorrectly: 'Entrez les informations correctement.',
    controlThatbeforeLoweEqualAfter: 'Le temps « Avant : » ne peut pas être inférieur à  « Après : »',
    ForceAssign: 'Forcer assignant',
    Allvehicletypes: 'Tous les types de véhicules',
    waitforconfirm: 'xxx (attendez pour confirmer)',
    waitforconfirm2: '(Attendez confirmer)',
    Dispatching: 'Dispatching',
    NoDriver: 'Pas de Chauffeur/Livreur',
    OtherDetails: 'Autres détails',
    StatusandDriver: 'Statut et Chauffeur/Livreur',
    EditStatusandDriver: 'Editer Statut et Chauffeur/Livreur',
    Current: 'En cours',
    EDAS_Pending: 'En attente',
    EDAS_Assigned: 'Attribué',
    EDAS_PickedUp: 'Ramassé',
    EDAS_Unassigned: 'Non attribué',
    EDAS_Started: 'Commencé',
    EDAS_Done: 'Terminé',
    EDAS_CustomerCanceled: 'Le client a annulé',
    EDAS_DriverCanceled: 'Chauffeur/Livreur annulé',
    EDAS_SupportCanceled: 'Le service technique a annulé',
    EDAS_Arrived: 'Arrivée',
    Pleasechooseadrivertochangestatus: "Veuillez choisir un chauffeur/livreur pour changer d'état",
    icWarningEdit: 'Les options changeantes peuvent effets sur le prix',
    Vehicletypewillbechanged: 'Le type de véhicule sera changé',
    Yourcurrentvehicletypeanditwillbechangedandeffectsonprice: 'Votre type de véhicule actuel sera modifié et aura des effets sur le prix',
    Rejected: 'Rejetée',
    Rejected2: '(Rejetée)',
    DriverVehicleTypeError: "Il n'y a pas de type de véhicule pour le Chauffeur/Livreur",
    CodeNameFamilyPhonenumber: 'Code, prénom, nom de famille, numéro de téléphone',
    youcanselectdriverintheedit: "Vous pouvez sélectionner le Chauffeur/Livreur dans l'édition du Chauffeur/Livreur et du statut",
    Earning: 'Revenus',
    savePrice: 'Enregistrer le prix',
    saveEarning: 'Enregistrer les gains',
    Total: 'Total',
    EditPickupDropOff: 'Adresses',
    noMoreData: "Il n'y a pas plus d'informations",
    OnDemand: 'À la demande',
    PD: 'R & D',
    PD2: 'R & D',
    PickupDropoff: 'Ramassage, Dépose',
    PickupFlag: 'R',
    DropOffFlag: 'D',
    PickupandDelivery: 'Ramassage et Dépose',
    PickupDelivery: 'Ramassage et Dépose',
    Delivery: 'Dépose',
    Collecting: 'En ramassage',
    Transit: 'Transit',
    Delivering: 'En dépose',
    EDAS_Collecting: 'En ramassage',
    EDAS_Transit: 'Transit',
    EDAS_Delivering: 'En dépose',
    statusCollecting: 'En ramassage',
    statusTransit: 'Transit',
    statusDelivering: 'En dépose',
    serviceCustomerError1: 'xxx n’est pas disponible pour ce client.',
    serviceCustomerError2: 'Il/elle peut choisir xxx Service',
    serviceCustomerError3: 'Il/elle peut seulement choisir xxx',
    OrderCode: 'Numéro de commande',
    event_Created: 'Créé',
    event_Unassigned: 'Non assigné',
    event_Assigned: 'Assigné',
    event_Started: 'Démarré',
    event_Arrived: 'Arrivé',
    event_PickedUp: 'Ramassé',
    event_OrderDone: 'Commande finalisée',
    event_DropoffDone: 'Dépose finalisée',
    event_CustomerFeedback: 'Commentaires du client',
    event_AddPod: 'Ajouter un PDD',
    event_CustomerCanceled: 'Client a annulé',
    event_DriverCanceled: 'Le chauffeur/livreur a annulé',
    event_SupportCanceled: 'Le service technique a annulé',
    event_Updated: 'Mis à jour',
    event_DriverAssignment: 'Affectation des chauffeurs/livreurs',
    event_DriverReject: 'Le chauffeur/livreur a annulé',
    event_Collecting: 'En ramassage',
    event_InTransit: 'En transit',
    event_Delivering: 'En dépose',
    event: 'Evénement',
    tab_Delivery: 'Dépose',
    tab_Ondemand: 'À la demande',
    tab_Pickup: 'Ramassage',
    tab_PickupDelivery: 'R&D',
    CurrentStatus: 'Statut actuel',
    Changestatus: 'Changer de statut',
    Newstatus: 'Nouveau statut',
    Savechanges: 'Enregistrer les modifications',
    Other: 'Autre',
    Shipmentlabel: "Étiquette d'expédition",
    pleaseSellectService: 'Veuillez sélectionner le type de service',
    EditPrice2: 'Prix',
    EditEarning: 'Gain',
    statusCustomerCanceled: 'Le client a annulé',
    Dutch: 'dutch',
    Ondemand: 'À la demande',
    todayat: "Aujourd'hui à",
    tomorrowat: 'Demain à',
    nextWeekat: 'La semaine prochaine à',
    lastDayat: 'Le lendemain à',
    lastWeekat: 'La semaine dernière à',
    CopyOrderlink: 'Copier le lien de la commande',
    CopyPickuplink: 'Copier le lien de ramassage',
    CopyDeliverylink: 'Copier le lien de la dépose',
    Bulkimport: 'Importer en bloc',
    Downloadsamplecsv: 'Télécharger un échantillon CSV',
    processing: 'En traitement',
    done: 'Complété',
    failed: 'Échoué ',
    Draft: 'Brouillon',
    Uploading: 'En chargement',
    Draganddropyourfile: 'Glisser et déposer votre fichier',
    Onlycsvformatissupported: 'Seul le format . csv est pris en charge',
    ORyoucan: 'Ou vous pouvez',
    Openfile: 'Ouvrir le fichier',
    Noimportsyet: 'Pas encore d’importations',
    NoimportsyetDesc: 'Vous pouvez voir la liste de vos importations ici et vérifier leur statut',
    nosupportdialogeTitle: 'Format de fichier non pris en charge',
    nosupportdialogeText: 'xxx fichier n’est pas pris en charge. vous pouvez seulement télécharger les fichiers . csv  y compris les informations de commande',
    ok: 'Ok',
    Import: 'Importation',
    previewTitle: 'Prévisualisez et choisissez les options',
    previewDesc: 'Il s’agit du premier élément de vos fichiers pour vérifier que vos informations sont dans la bonne structure',
    Upload: 'Charger',
    Remove: 'Supprimer',
    ServiceandOrdertype: 'Type de service et de commande',
    Fileisproccessing: 'Le fichier est en cours de traitement...',
    proccessingDesc: 'Vous pouvez rafraîchir pour voir si le résultat est prêt',
    serverError: 'Erreur du serveur',
    isRequired: 'xxx est requis',
    Result: 'Résultat',
    ResultText: 'Vous pouvez voir les problèmes ici et télécharger ces lignes pour les corriger séparément',
    ErrorDetails: 'Commandes avec erreur',
    ErrorDetailsText: 'Les commandes comportant des erreurs sont répertoriées dans le fichier que vous pouvez télécharger ci-dessous. Il contient les détails d’erreur pour chaque ligne.',
    DownloadErroredRows: 'Télécharger les lignes erronées',
    importedsuccessfully: 'xxx commandes importées avec succès',
    ordershaserrors: 'xxx commandes contient des erreurs',
    refresh: 'Rafraîchir',
    CashOnDelivery: 'paiement à la dépose',
    EnterAmount: 'Saisir le montant',
    COD: 'Paiement à la dépose',
    Surchargexxx: 'Surtaxe xxx',
    AddCreditCard: 'Ajouter une carte de crédit ou de débit',
    CustomerWallet: 'Porte-monnaie du client',
    Add: 'Ajouter',
    Addedsuccessfully: 'Ajouté avec succès',
    NoRecentAddress: 'Aucune adresse récente',
    NoRecentAddressD: 'Les adresses récentes des clients seront indiquées ici.',
    CustomerIsNotChoosed: 'Le client n’a pas été choisi',
    CustomerIsNotChoosedD: 'Choisissez le client pour afficher son adresse récente.',
    SearchAddress: 'Recherche une adresse',
    NoCustomerfound: 'Aucun client trouvé',
    NoCustomerfoundD: 'Vous pouvez créer le client s’il est nouveau',
    NewCustomer: 'Nouveau client',
    Existing: 'Existant',
    EmailOtional: 'Email (facultatif)',
    phonenumberisnotcorrect: 'Numéro de téléphone incorrect',
    Emailisnotcorrect: 'Email incorrect',
    Registercustomer: 'Inscrire le client',
    incoming: 'Appel entrant',
    outgoing: 'Appel sortant',
    recording: 'Enregistrement de l’appel',
    driveroperatorCallStatus: 'Le chauffeur/livreur a appelé l’opérateur',
    customeroperatorCallStatus: 'Le client a appelé l’opérateur',
    newCustomeroperatorCallStatus: "Le nouveau client a appelé l'opérateur",
    operatordriverCallStatus: "L'pérateur a appelé le chauffeur/livreur",
    operatorcustomerCallStatus: "L'opérateur appelé le client",
    operatornewCustomerCallStatus: "L'opérateur a appelé le nouveau client",
    dispatcher_Voip: 'Opérateur',
    driver_Voip: 'Chauffeur/livreur',
    customer_Voip: 'Client',
    activeorders: 'xxx commandes actives',
    Noactiveorder: 'Aucune commande active',
    CreateOrder: 'Créer une commande',
    call: 'Appeler',
    spanish: 'Espagnol',
    es: 'Espagnol',
    networkError: 'Pas de connexion internet',
    germany: 'Allemand',
    de: 'Allemand',
    Itisnotpossibletorepeattherequest: 'Il n’est pas possible de répéter la commande',
    createdAt: 'Créé à',
    dueDate: "Date d'échéance",
    Noresultfound: 'Aucun résultat trouvé',
    loadMore: 'Charger plus',
    Searchresult: 'Résultat de recherche',
    AssignedAt: 'Attribuer jusqu’à xxx',
    StartedAt: 'Début jusqu’à xxx',
    ArrivedAt: 'Arrivée jusqu’à xxx',
    PickedUpAt: 'Ramassage à xxx',
    DoneAt: 'Terminé à xxx',
    mindelay: 'xxxm de retard',
    minlate: 'xxxm tard',
    PinTop: 'Épingler',
    UnPin: 'Détacher',
    Itemsonmap: 'Articles sur la carte',
    min: 'xxx min',
    Confirming: 'Confirmation',
    delay: 'Retard',
    late: 'Tard',
    OrderDetails: 'Détails de la commande',
    Profile: 'Profil',
    Waitingforavailabledrivers: 'Attendre que les chauffeurs/livreurs soient disponibles',
    Queue: "File d'attente",
    OfferingToDrivers: 'Offre aux chauffeurs/livreurs xxx',
    WaitforAccept: 'Attendre pour accepter',
    Thereisnoorder: "il n'y a pas de commande",
    mapitems: 'Eléments de carte',
    Offerings: 'Offres',
    Reject: 'Rejeter',
    dropoffCustomerDescription: 'Note de dépose',
    customerPhoto: 'Photo du client',
    driverPhoto: 'Photo du chauffeur/livreur',
    NocustomerPhoto: 'Pas de photo du client',
    NodriverPhoto: 'Pas de photo du chauffeur/livreur',
    initial: 'Initial',
    notifying: 'Notifiant',
    received: 'Reçu',
    assigned: 'Assigné',
    rejected: 'Rejeté',
    canceled: 'Annulé',
    standby: 'En attente',
    terminated: 'Terminé',
    urgentTitle: "Passer à l’envoi 'Urgent'?",
    urgentDesc: "En activant 'Urgent', la commande sera en priorité pour la dépose",
    urgentConfirm: "Oui, activer 'Urgent'",
    urgentClose: 'Non, annuler',
    Urgent: 'Urgent',
    photos: 'Photos',
    Portuguese: 'Portugais',
    Dispatchat: 'Envoi à xxx',
    AutoDispatch: 'Envoi automatique',
    Dispatchtime: "Délai d'expédition",
    Later: 'Plus tard',
    DispatchingNow: 'Expédier maintenant',
    NoResultfromLocalDatabase: 'Aucun résultat de la base de données locale',
    NoResultfromLocalDatabaseD: 'Veuillez vérifier à nouveau ou essayer un autre mot-clé',
    now: 'Maintenant',
    ascending: 'Ascendant',
    descending: 'Descendant',
    Last3Month: 'Les trois derniers mois',
    Pickupnote: 'Note de ramassage',
    pop: 'Preuve de ramassage',
    Required: 'Requis',
    SearchinMapService: 'Recherche dans le service de carte',
    SearchinLocalDatabase: 'Recherche dans la base de données locale',
    Creditcardnotadded: 'Carte de crédit non ajoutée',
    OptimizeDropoffs: 'Optimiser les déposes',
    Greek: 'Grec',
    el: 'Grec',
    ReferenceID: 'ID de référence',
    EnterId: "Entrez l'ID",
    German: 'Allemand',
    AustrianGerman: 'Allemand autrichien',
    EDAS_PickupFailed: 'Échec du ramassage',
    EDAS_Lost: 'Perdu',
    EDAS_Returned: 'Retourné',
    EDAS_Draft: 'Ébauche',
    EDAS_Confirmed: 'Confirmé',
    EDAS_PickupRouted: 'RamassageRouté',
    EDAS_ReadyForPickup: 'Prêt pour le ramassage',
    EDAS_AtWarehouse: "À l'entrepôt",
    EDAS_DeliveryRouted: 'Livraison expédiée',
    EDAS_ReadyForDelivery: 'PrêtPourLaLivraison',
    EDAS_OutForDelivery: 'SortiePourLivraison',
    EDAS_Delivered: 'Livré',
    EDAS_NotDelivered: 'Non livré',
    EDAS_ForReturn: 'Pour le retour',
    NoResultfromMapService: 'Aucun résultat du service de carte',
    Options: 'Possibilités',
    VehicleOptions: 'Options du véhicule',
    EditCustomer: 'Modifier le client',
    NoDriverfound: 'Aucun pilote trouvé',
    NoDriverfoundDesc: 'Vérifiez vos renseignements et essayez autre chose',
    ClearField: 'Effacer le champ',
    Map: 'Carte',
    Local: 'Local',
    CompleteRequiredFeileds: 'Remplissez les champs obligatoires',
    Senderinfo: "Informations sur l'expéditeur",
    Receiverinfo: 'Informations sur le récepteur',
    'SchedulePickup(Optional)': 'Planifier le ramassage (facultatif)',
    'ScheduleDelivery(Optional)': 'Planifier la livraison (optionnel)',
    AddDropoff: 'Ajouter un dépôt',
    Promotion: 'Promotion',
    tax: 'Impôt',
    Shipmentlabeldownloaded: "Étiquette d'expédition téléchargée",
    statusDraft: 'Ébauche',
    statusConfirmed: 'Confirmé',
    statusPickupRouted: 'RamassageRouté',
    statusReadyForPickup: 'Prêt pour le ramassage',
    statusAtWarehouse: "À l'entrepôt",
    statusDeliveryRouted: 'Livraison expédiée',
    statusReadyForDelivery: 'PrêtPourLaLivraison',
    statusOutForDelivery: 'SortiePourLivraison',
    statusDelivered: 'Livré',
    statusNotDelivered: 'Non livré',
    statusForReturn: 'Pour le retour',
    statusReturned: 'Retourné',
    statusPickupFailed: 'Échec du ramassage',
    statusLost: 'Perdu',
    event_Draft: 'Ébauche',
    event_Confirmed: 'Confirmé',
    event_PickupRouted: 'RamassageRouté',
    event_ReadyForPickup: 'Prêt pour le ramassage',
    event_AtWarehouse: "À l'entrepôt",
    event_DeliveryRouted: 'Livraison expédiée',
    event_ReadyForDelivery: 'PrêtPourLaLivraison',
    event_OutForDelivery: 'À part la livraison',
    event_Delivered: 'Livré',
    event_NotDelivered: 'Non livré',
    event_ForReturn: 'Pour le retour',
    event_Returned: 'Retourné',
    event_PickupFailed: 'Échec du ramassage',
    event_Lost: 'Perdu',
    event_IncomingCall: 'Appel entrant',
    event_OutgoingCall: 'Appel sortant',
    event_DispatchOrder: "Commande d'expédition",
    tryagain: 'Quelque chose a mal tourné, veuillez réessayer',
    'Selected date and time': 'Date et heure choisies',
    'Reorder stops': 'Réorganiser les arrêts',
    'Bulk Edit Status Summary': "Résumé de l'état de la modification de groupe",
    Successful: 'Fructueux',
    Failed: 'Échoué',
    'Order ID': 'Numéro de commande',
    'Pickup Routed': 'Ramassage acheminé',
    'Delivery Routed': 'Livraison expédiée',
    'Ref. xxx': 'Réf. xxx',
    Zone: 'Zone',
    Clear: 'Clair',
    'No result found': 'Aucun résultat trouvé',
    'Type your keyword': 'Tapez votre mot-clé',
    'Type in the input to start search': "Tapez l'entrée pour lancer la recherche",
    'We are sorry ...': 'Nous sommes désolés...',
    'The page you are trying to access has restricted access.': "La page à laquelle vous essayez d'accéder a un accès restreint.",
    'Please refer to your system administrator.': 'Veuillez vous référer à votre administrateur système.',
    'Proof of delivery': 'Preuve de livraison',
    'Driver Photo': 'Photo du conducteur',
    'Order Info': 'Renseignements sur la commande',
    'P_HUB_D Orders': 'Commandes P_HUB_D',
    Routes: 'Itinéraires',
    'Default pickup': 'Ramassage par défaut',
    More: 'Plus',
    'Route name': "Nom de l'itinéraire",
    Driver: 'Conducteur',
    'Pickup Orders': 'Commandes de ramassage',
    'Delivery Orders': 'Bons de livraison',
    'Ready For Pickup': 'Prêt à ramasser',
    PricingAndEarning: 'Tarifs et gains',
    Pricing: 'Tarifs',
    save: 'Sauver',
    Learn: 'Apprendre',
    Scheduleoverlap: "L'heure prévue de ramassage doit être antérieure à l'heure prévue de livraison et ne doit pas se chevaucher.",
    PleaseSelectCustomer: 'Veuillez choisir un client',
    NoRegisteredCustomer: 'Aucun client inscrit',
    CreateAtLeastOneCustomerToCreateOrder: 'Créez au moins un client pour créer une commande',
    Pinned: 'Épinglé',
    Delayed: 'Retardé',
    Canceled: 'Annulé',
    InProgress: 'En cours',
    DispatchLater: 'Expédition plus tard',
    Table: 'Table',
    'Clear All': 'Tout effacer',
    'Config Table': 'Tableau de configuration',
    'Active Columns': 'Colonnes actives',
    'Due time': 'Délai',
    'Search route name': "Trouver le nom de l'itinéraire",
    'Add Route': 'Ajouter un itinéraire',
    'Route info': "Renseignements sur l'itinéraire",
    'Start Location': 'Lieu de départ',
    'End Location ( Optional )': 'Emplacement de fin (facultatif)',
    'Load Deliveries:': 'Charger les livraisons :',
    No: 'Non',
    Optional: 'Facultatif',
    Force: 'Forcer',
    'Code, Name, Family, Phone number': 'Code, Nom, Famille, Numéro de téléphone',
    'Edit Route Status & Driver': "Modifier l'état de l'itinéraire et le conducteur",
    'No, Cancel': 'Non, annuler',
    'Yes, Optimize': 'Oui, optimiser',
    'Optimize Stops?': 'Optimiser les arrêts ?',
    'The sequence of stops changes automatically. you can change it manually later': 'La séquence des arrêts change automatiquement. vous pourrez le modifier manuellement plus tard',
    'Error in loading data': 'Erreur lors du chargement des données',
    'There was a problem loading data. please try again or contact support': 'Un problème est survenu lors du chargement des données. veuillez réessayer ou contacter le soutien',
    'Try again': 'Essayer de nouveau',
    'Duration:': 'Durée:',
    'Edit Route info': "Modifier les renseignements sur l'itinéraire",
    'Edit Status & Driver': 'Modifier le statut et le pilote',
    'Reorder Stops': 'Réorganiser les arrêts',
    Optimize: 'Optimiser',
    'Search stops': 'Arrêts de recherche',
    'Delivery:': 'Livraison:',
    'Pickup:': 'Ramasser:',
    'No Stop was found': "Aucun arrêt n'a été trouvé",
    'Please check it again or try another keyword': 'Veuillez le revérifier ou essayer un autre mot-clé',
    'Add your orders': 'Ajoutez vos commandes',
    'You can add orders from orders pages': 'Vous pouvez ajouter des commandes à partir des pages de commandes',
    'Go to Orders': 'Aller aux commandes',
    'On Demand': 'Sur demande',
    P_Hub_D: 'P_Hub_D',
    Notifications: 'Notifications',
    'Admin Center': "Centre d'administration",
    'Sort by': 'Trier par',
    'Sort type': 'Type de tri',
    OrderType: 'Type de commande',
    Stage: 'Stade',
    Status: 'Statut',
    Route: 'Route',
    CreatedAt: 'Créé à',
    StatusUpdatedAt: 'StatutMise à jour',
    Note: 'Remarque',
    'Delivery Last Attempt Reason': 'Raison de la dernière tentative de livraison',
    'Delivery Attempts Count': 'Nombre de tentatives de livraison',
    'Pickup Failed Reason': "Raison de l'échec de la collecte",
    ReferenceId: 'ID de référence',
    PickupAddress: 'Adresse de ramassage',
    DeliveryAddress: 'Adresse de livraison',
    'Driver Name': 'Nom du pilote',
    'Driver Phone': 'Téléphone du conducteur',
    'Customer Name': 'Nom du client',
    'Customer Phone': 'Téléphone du client',
    EstimatedDistanceInMeters: 'DistanceEstimée En Mètres',
    EstimatedDuration: 'Durée estimée',
    'Payment Method': 'Mode de paiement',
    PickupAddressDetail: "Détails de l'adresse de ramassage",
    PickupCompleteAfter: 'RamassageCompletAprès',
    PickupcompleteBefore: 'Ramassage completAvant',
    PickupFullName: 'RamassageFullName',
    PickupPhone: 'RamassageTéléphone',
    PickupEmail: 'RamassageCourriel',
    PickupPodNote: 'PickupPodNote',
    PickupPodPhoto: 'PickupPodPhoto',
    PickupPodSignature: 'PickupPodSignature',
    PickupZone: 'Zone de ramassage',
    DeliveryAddressDetail: 'LivraisonAdresseDétail',
    DeliveryCompleteAfter: 'Livraison terminée après',
    DeliverycompleteBefore: 'Livraison terminéeAvant',
    DeliveryFullName: 'LivraisonFullName',
    DeliveryPhone: 'LivraisonTéléphone',
    DeliveryEmail: 'Livraison par courriel',
    DeliveryPodNote: 'LivraisonPodNote',
    DeliveryPodPhoto: 'LivraisonPodPhoto',
    DeliveryPodSignature: 'Signature du module de livraison',
    DeliveryZone: 'Zone de livraison',
    'Driver Vehicle': 'Véhicule conducteur',
    'Driver Username': "Nom d'utilisateur du pilote",
    CustomerType: 'Type de client',
    'Customer Email': 'Courriel du client',
    PaymentProvider: 'Fournisseur de paiement',
    Source: 'Source',
    'Shipment Label': "Étiquette d'expédition",
    'Track Order': 'Suivre la commande',
    'Create your first order': 'Créez votre première commande',
    'Your orders will be shown here in table with full details and actions': 'Vos commandes seront affichées ici dans un tableau avec tous les détails et actions',
    'Please check your filters or keyword': 'Veuillez vérifier vos filtres ou mot-clé',
    from: 'de',
    rows: 'lignes',
    Prev: 'Précédent',
    Next: 'Suivant',
    Stages: 'Étapes',
    RouteName: "Nom de l'itinéraire",
    Services: 'Services',
    PaymentSides: 'Côté paiement',
    pickupzones: 'zones de ramassage',
    deliveryzones: 'zones de livraison',
    Zones: 'Zones',
    CodAmount: 'Montant de la morue',
    'Payment Methods': 'Méthodes de paiement',
    'Delivery Attempt Number': 'Numéro de tentative de livraison',
    paymentMethods: 'Méthodes de paiement',
    'Edit Status': 'Modifier le statut',
    'Select Status': 'Sélectionnez le statut',
    'Select Reason': 'Choisissez la raison',
    'Select Route': 'Sélectionner un itinéraire',
    'Don’t change routes': "Ne changez pas d'itinéraire",
    'Edit routes': 'Modifier les itinéraires',
    'Remove routes': 'Supprimer des itinéraires',
    'You must assign driver to select this route': 'Vous devez désigner un chauffeur pour choisir cet itinéraire',
    'You must choose an unassigned route or unassign selected route': "Vous devez choisir un itinéraire non attribué ou désattribuer l'itinéraire sélectionné",
    'Create P_HUB_D Only order': 'Créer une commande P_HUB_D',
    'Add routes': 'Ajouter des itinéraires',
    'Your routes will be shown here in': 'Vos itinéraires seront affichés ici dans',
    'Add orders': 'Ajouter des commandes',
    'Bulk select in orders list and add orders with edit status button': 'Sélectionnez en masse dans la liste des commandes et ajoutez des commandes avec le bouton Modifier le statut',
    'Create Ondemand order': 'Créer une commande sur demande',
    'Your orders will be shown here in list': 'Vos commandes seront affichées ici dans la liste',
    'Create Pickup Only order': 'Créer une commande à emporter seulement',
    'Create Delivery Only order': 'Créer une commande avec livraison seulement',
    'No offline driver': 'Aucun pilote hors ligne',
    'Offline drivers will be shown here': 'Les pilotes hors ligne seront affichés ici',
    'No online driver': 'Aucun pilote en ligne',
    'Online drivers will be shown here': 'Les pilotes en ligne seront affichés ici',
    'Driver login info': 'Informations de connexion du conducteur',
    'Driver must be online in the app to see it here  and be able to assign orders': "Le chauffeur doit être en ligne dans l'application pour le voir ici et pouvoir attribuer des commandes",
    'Scan to Download Driver app': "Numériser pour télécharger l'application pilote",
    OR: 'OU',
    'Open the link in your phone': 'Ouvrez le lien sur votre téléphone',
    'Copy link to clipboard': 'Copier le lien dans le presse-papiers',
    'Copied!': 'Copié!',
    'Add drivers': 'Ajouter des pilotes',
    Pleaseselectroutefromsearchresults: 'Veuillez choisir un itinéraire dans les résultats de recherche',
    Addroutestobeabletosearchandselectroute: 'Ajoutez des itinéraires pour pouvoir rechercher et sélectionner un itinéraire',
    NoRoutes: 'Aucun itinéraire',
    Searchandselectroute: 'Rechercher et choisir un itinéraire',
    EDROPANDDE2: 'Seuls les itinéraires non attribués sont autorisés pour ce statut',
    EDROPANDDE1: 'Seuls les itinéraires assignés ou démarrés sont autorisés pour ce statut',
    'Help center': "Centre d'aide",
    Pleasetryanotherkeyword: 'Please try another keyword',
    'Demo tip': 'Demo tip',
    'Add your driver in admin center': 'Add your driver in admin center',
    selected: 'selected'
  };